/**
 *
 * This condition is never scheduled because:
 *
 * The event has a start date and its either on sale (before the event starts) or not on sale (after the event starts).
 *
 * The event does not have a start date and we consider this to be not on sale.
 */
const handleUntilEventStartsScheduled = () => {
  return { isScheduled: false, hasInvalidReference: false };
};

export default handleUntilEventStartsScheduled;
